<span class="inner" [ngClass]="[color ?? '']" appRipple>
  <ng-content></ng-content>
</span>
